import type { VerifyFidexaHubOtpType } from "@/domain/fidexaHub/fidexaHubAuthType";
import type { UseMutateFunction } from "@tanstack/react-query";
import { createContext, useContext } from "react";

/**
 * Por que a sessão acabou. Só existe para a UI conseguir DIFERENCIAR o
 * cliente que saiu por vontade própria daquele que a API derrubou —
 * ambos terminam na mesma tela de resume, e sem essa distinção o segundo
 * caso vira uma volta silenciosa pro formulário de telefone, como se o
 * login que ele acabou de fazer simplesmente não tivesse acontecido.
 *
 * "rejected" cobre tanto expiração quanto revogação: o bearer do
 * FidexaHub é opaco (não dá pra ler `exp` no cliente), então a única
 * informação disponível é o 401 do interceptor.
 */
export type FidexaHubSessionEndReason = "rejected";

export type FidexaHubAuthContextType = {
  sessionToken: string | null;
  isAuthenticated: boolean;
  isSessionLoaded: boolean;
  sessionEndReason: FidexaHubSessionEndReason | null;
  clearSessionEndReason: () => void;
  setSession: (token: string, memberId: string) => void;
  verifyOtp: UseMutateFunction<void, Error, VerifyFidexaHubOtpType, unknown>;
  isVerifyingOtp: boolean;
  logout: () => void;
};

export const FidexaHubAuthContext = createContext<FidexaHubAuthContextType>(
  {} as FidexaHubAuthContextType
);

export const useFidexaHubAuth = () => {
  const context = useContext(FidexaHubAuthContext);
  if (!context) {
    throw new Error(
      "useFidexaHubAuth must be used within a FidexaHubAuthProvider"
    );
  }
  return context;
};
